export default "__VITE_ASSET__a039c4ca__"